import React from "react"

import PopoverMenuOption from "../../popover-menu/popover-menu/menu-option"
import {PinData, PinLocationTypes} from "../../../model2/pin/@types"
import {pinItem, unPinItem, updatePinItemLocation} from "../actions/pin-item"
import {PopoverMenuItemType} from "../../popover-menu/popover-menu/const"
import PopoverMenuSeparator from "../../popover-menu/popover-menu/popover-menu-separator"
import Workspace from "../../../model2/space/workspaces/workspace"

type Props = {
    menuParams  : {
        data        : PinData
    }
    hidePopover : func
}

// const debug = "PinMenu"
const debug = false

export default function PinMenu(props: Props) {

    const pin = gd.session.pins.getPinByData(props.menuParams.data)
    const isPinned  = !!pin
    const workspaceId = pin?.location.type === PinLocationTypes.WORKSPACE ? pin.location.value : null

    const {projectId} = props.menuParams.data
    let parentWorkspaceId: ID | undefined
    if (projectId) {
        parentWorkspaceId = gd.session.projects.get(projectId)?.workspace?.id
    }

    const onUnPin = async () => {
        await unPinItem(props.menuParams.data)
        // props.hidePopover() // gd.layout.popovers.closeAll will hide popover

        gd.layout.popovers.closeAll()
    }

    const onPinHome = async () => {
        if (isPinned) {
            await updatePinItemLocation(props.menuParams.data, {
                type: PinLocationTypes.HOME
            })
        } else {
            await pinItem(props.menuParams.data, (isPinned: boolean)=>{
                if (isPinned) {
                    gd.bus.triggerEvent('section-change','home', props.menuParams.data)
                }
            })
        }

        props.hidePopover()
    }

    const onPinToWorkspace = async (workspace: Workspace) => {

        if (isPinned) {
            await updatePinItemLocation(props.menuParams.data, {
                type    : PinLocationTypes.WORKSPACE,
                value   : workspace.project.id
            })

        } else {

            const data: PinData = _.clone(props.menuParams.data)
            data.location = {
                type    : PinLocationTypes.WORKSPACE,
                value   : workspace.project.id
            }

            await pinItem(data, (isPinned: boolean)=>{
                if (isPinned) {
                    gd.bus.triggerEvent('section-change','workspace', props.menuParams.data)
                }
            })
        }

        props.hidePopover()
    }

    const options: Option[] = []

    options.push({
        icon        : 'i5-nav-home',
        label       : 'Home',
        isSelected  : isPinned && !workspaceId,
        onClick     : onPinHome
    })

    // restrict pin to own workspace
    const workspacesToShow = _.filter(gd.spaces.workspaces.models, (workspace: Workspace) => {
        return workspace.id !== parentWorkspaceId
    })

    if (!_.isEmpty(workspacesToShow)) {
        options.push({
            type        : PopoverMenuItemType.SEPARATOR,
        })
    }

    _.map(workspacesToShow, (workspace: Workspace) => {
        options.push({
            icon        : gd.const.project.icon[workspace.project.projectIcon],
            label       : workspace.project.name,
            isSelected  : isPinned && workspaceId === workspace.project.id,
            onClick     : () => onPinToWorkspace(workspace)
        })
    })

    if (isPinned) {
        options.push({
            type        : PopoverMenuItemType.SEPARATOR,
        })
        options.push({
            icon        : 'i5-none',
            label       : 'Delete Pin',
            onClick     : onUnPin
        })
    }

    debug && console.log(debug, 'render', options, gd.session.projects.workspaces)

    return (
        <div className="ui5-popover-menu max-w-300">
            {_.map(options, (option: Option, key) => {
                if (option.type === PopoverMenuItemType.SEPARATOR) {
                    return <PopoverMenuSeparator key={key}/>
                }

                return <PopoverMenuOption key      = {key}
                                          option   = {option}/>
            })}
        </div>
    )
}